import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectUwReports = createSelector(selectLoanApplication, ({ uwReports }) => uwReports);

export const selectUwReportsList = createSelector(selectUwReports, Object.values);
